import { useState } from 'react';
import { AuthApi } from '@/services/auth.service';
import { tokenStorage } from '@/api/tokenManager';
import { LoginRequest } from '../../../types/authentication.types';
import { useT } from '@/i18n';

export const useLogin = () => {
    const { t } = useT();
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (credentials: LoginRequest) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await AuthApi.login(credentials);
            if (response && response.access_token) {
                tokenStorage.setTokens(response.access_token, response.refresh_token);
            }
            return response;
        } catch (err: any) {
            console.error('Login error:', err);
            if (err.response && err.response.status === 401) {
                setError(t('login.error_invalid_credentials'));
            } else if (err.request) {
                setError(t('login.error_network'));
            } else {
                setError(t('login.error_generic', { message: err.message }));
            }
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        handleLogin,
        error,
        isLoading,
    };
};